module.exports = __webpack_public_path__ + "static/friendtime-098cebc873507193fbb26bf8957757bf.png";